import { fromJS } from 'immutable';

import { SET_TRACKED_ASSET_DATA } from './constants';

const initialState = fromJS({
  data: {},
});

function trackAssetModalReducer(state = initialState, action) {
  switch (action.type) {
  case SET_TRACKED_ASSET_DATA:
    return state
      .set('data', action.data);
  default:
    return state;
  }
}

export default trackAssetModalReducer;



/** WEBPACK FOOTER **
 ** ./src/containers/track-asset-modal/reducer.js
 **/